var _module_exports = "<span>This project was abandoned. <a style=\"text-transform: uppercase\" ng-click=\"flashScope.showIntercom()\">CONTACT CUSTOMER SUPPORT</a>.</span>\n";;
var path = 'views/flashes/task_abandoned.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;